import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { CloseSquareOutlined } from '@ant-design/icons';
import classes from './FailedPayment.module.scss';
import { useAppSelector } from 'store/hook';
import { useSearchParams } from 'react-router';
import { paymentUrl } from 'api/billing';
import { getTheme } from 'helpers/getTheme';

type FailedPaymentPops = {
  isOpen: boolean;
  onCancel: () => void;
};

const FailedPayment = ({ isOpen, onCancel }: FailedPaymentPops) => {
  const { userData } = useAppSelector((store) => store.userData);

  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  
  React.useEffect(() => {
    if (searchParams.get('message') === 'recreate') {
      recreateBill();
    }
  },[]);
  
  const recreateBill = () => {
    const params = window.location.href.split('message=recreate&')[1];
    if (params) {
      // const correctParams = params.replace('&redirect=true', '%26redirect=true');
      window.location.href = `${paymentUrl}?${params}`;
    };
  };

  return (
    <Modal
      open={isOpen}
      width={'60%'}
      onCancel={onCancel}
      onOk={onCancel}
      centered
      className={getTheme()}
      cancelButtonProps={{style: {display: 'none'}}}
    >
      <div className={classes.confirmWrap}>
        <CloseSquareOutlined className={classes.errorIcon}/>
        <div className={classes.textConfirm}>
          <p>{t('payment.dear')} {userData?.first_name} {userData?.last_name}</p>
          <p>{t('payment.paymentFailed')}</p>
          <p>{t('payment.tryLater')}</p>
          <p>{t('payment.writeUs')}</p>
        </div>
      </div>
    </Modal>
  );
};

export default FailedPayment;
